import React, {Component} from 'react'
import axios from 'axios'
import StartPage from '../StartPage/StartPage'
import Questions from '../Questions/Questions'
import Loader from '../Loader/Loader'

import './app.module.scss'

class App extends Component {
   state = {
      isClose: false,
      loading: false,
      ques: {},
      postDataObj:{},
      error: null
   }
   closeQuiz = () => {
      const rootBlock = document.querySelector('#quizContainer')
      const rootBody = document.querySelector('body')
      this.setState({isClose: true})
      rootBlock.style.background = 'transparent'
      rootBody.style.background = 'transparent';      
   }

   postDataIntoState = (e) => {
      const { ques } = this.state;
      const { name_param_question } = ques;
      
      this.setState({
         postDataObj: { ...this.state.postDataObj, [name_param_question]:  e.currentTarget.value}
      })
   }
   nextQuestion = () => {

      const { postDataObj } = this.state;
      
      this.setState({ loading: true });
      
      axios
         .post(`/wp-json/api/v1/quiz/next`, {
            user_uid: localStorage.getItem('id'),
            answers: postDataObj
         })
         .then(response => {
            if (!localStorage.getItem('id')) {
               localStorage.setItem('id', response.data.data.user_uid)
            } 
            this.setState({ ques: response.data.data.question ? response.data.data.question : response.data.data.final })
            if (response.data.data.final&&!localStorage.getItem('time')) {
               localStorage.setItem('time', Date.now())
            } 
         })
         .catch(error => this.setState({ error: error }))
         .finally(() => this.setState({ loading: false }));
   }

   componentDidMount() {
      const rootBlock = document.querySelector('#quizContainer')
      const rootBody = document.querySelector('body')
      rootBlock.style.background = 'linear-gradient(167.77deg, #9AD8ED 6.5%, #9ED6EA 91.09%)'
      rootBody.style.background = 'linear-gradient(167.77deg, #9AD8ED 6.5%, #9ED6EA 91.09%)';
      let vh = window.innerHeight;
      if (document.body.clientWidth < 768) {
         rootBlock.style.height = `${vh}px`;
      }
      let searchParams = new URLSearchParams(document.location.search);
      let obj;
      for (const key of searchParams.keys()) {
         obj = {...obj, [key]: searchParams.get(key)}
      }
      this.setState({ postDataObj: obj });

      if (localStorage.getItem('id')) {
         this.nextQuestion();
      } 
   }

   render() {
      const { loading, ques, isClose } = this.state;
      
      return (
         <>
            {!isClose &&
               <StartPage openQuiz={this.nextQuestion} closeQuiz={this.closeQuiz}>
                  {
                     loading ?
                     <Loader/>
                     :
                     localStorage.getItem('id') &&
                     <Questions questions={ques} onMouseDown={this.postDataIntoState} onMouseUp={this.nextQuestion}/>
                  }                  
               </StartPage>
            }
         </>
      )
   }
}

export default App